import { LogisticResponse } from 'app/modules/logistic/model/logistic.response';
import { BenefitClaimResponse } from '../../model/benefitClaim.response';
import { BonTransportConstraint } from '../../model/bonTransportConstraint.response';

export const initialState = {
  loading: false,
  loadingGeolocation: false,
  logisticResponse: new LogisticResponse(),
  benefitClaimResponse: new BenefitClaimResponse(),
  geolocalisation: null,
  geolocalisationModal: false,
  bonTransportConstraint: new BonTransportConstraint(),
  bonTransportError: false,
};

export type LogisticState = Readonly<typeof initialState>;
